/**
 * staffType:
 * 企业帐号(100)
 * 二级监管机构操作员(200)
 * 二级监管机构管理员(202)
 * 一级监管机构管理员(208)
 * 运营端帐号(1000)
 *
 */
const ENT = 100
const LEVEL_ONE_SUPERVISE = 208
const LEVEL_TWO_SUPERVISE = 202
const LEVEL_TWO_OPERATE = 200
const OPERATE = 1000
export default {
  formatPermissionType: (type, isAdmin) => {
    return {
      ENT: type === ENT,
      ENT_ADMIN: type === ENT && isAdmin === 1,
      ENT_OPERATE: type === ENT && isAdmin === 0,
      OPERATE: type === OPERATE,
      LEVEL_ONE_SUPERVISE: type === LEVEL_ONE_SUPERVISE,
      LEVEL_TWO_SUPERVISE: type === LEVEL_TWO_SUPERVISE,
      LEVEL_TWO_OPERATE: type === LEVEL_TWO_OPERATE,
      SUPERVISE:
        type === LEVEL_ONE_SUPERVISE ||
        type === LEVEL_TWO_SUPERVISE ||
        type === LEVEL_TWO_OPERATE
    }
  }
}
